import styled from 'styled-components';

export const Container = styled.div`
  // position: sticky;
  // top: 0; // 상단에 고정
  // z-index: 1000;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 12px 2rem 0;
`;

export const Container2 = styled.div`
  align-items: center;
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  height: 60px;
`;

export const Container3 = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between; // 항목을 페이지 너비에 맞게 배치
  width: 100%; // 컨테이너가 페이지 너비에 맞게 조정되도록 설정
`;

export const Container4 = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 3rem 2rem 0;
`;

export const Container5 = styled.div`
  margin: 16px;
  display: flex;
  width: 335px;
  align-items: flex-start;
  gap: 16px;
`;

export const Container6 = styled.div`
  margin: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  margin-bottom: 16px;
`;

export const Container7 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

export const Container8 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
`;

export const Container9 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

export const DefaultInfoText = styled.div`
  color: var(--Gray-Scale-600, #756f7e);
  font-family: 'Pretendard Variable';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: -0.24px;
  line-height: 1.64;
  min-width: 75px;
`;

export const DefaultInfoText2 = styled.div`
  color: var(--Gray-Scale-400, #bcb8c3);
  font-family: 'Pretendard Variable';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: -0.32px;
`;

export const RowDivider = styled.div`
  margin-top: 24px;
  margin-bottom: 24px;
  background: var(--BG-bg-800, #1e1b24);
  width: 100%;
  height: 8px;
  box-sizing: border-box;
`;

export const RowDivider2 = styled.div`
  margin-top: 12px;
  margin-bottom: 12px;
  background: #1e1b24;
  width: 100%;
  height: 1px;
`;

export const ButtonText = styled.button`
  color: var(--Brand-300, var(--C79EF0, #9170f2));
  font-family: 'Pretendard Variable';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px; /* 131.25% */
  letter-spacing: -0.32px;
  background: none; /* 버튼 배경 제거 */
  border: none; /* 버튼 테두리 제거 */
  padding: 0; /* 패딩 제거 */
  cursor: pointer; /* 클릭 가능한 커서로 변경 */
  text-align: left; /* 텍스트 정렬 조정 */
`;

export const CustomTextArea = styled.textarea`
  margin: 16px;
  width: 90%; /* 컨테이너의 너비에 맞게 조정, 필요에 따라 고정 값으로 설정 가능 */
  height: 160px; /* 고정된 높이 설정 */
  padding: 16px;
  border-radius: 8px;
  background: var(--BG-bg-700, #262231);
  color: #fff; /* 텍스트 색상 설정 */
  border: 1px solid var(--BG-bg-500, #373245); /* 테두리 색상 설정 (선택 사항) */
  box-sizing: border-box; /* 패딩과 테두리가 요소의 총 너비에 포함되도록 설정 */
  margin-top: 0; /* 위쪽 마진 조정 */
  margin-bottom: 0; /* 아래쪽 마진 조정 */

  /* 줄 바꿈 및 단어 처리 */
  white-space: pre-wrap; /* 공백과 줄 바꿈을 유지하며 텍스트를 자동으로 줄 바꿈 */
  overflow-wrap: break-word; /* 긴 단어가 컨테이너를 넘어가지 않도록 자동으로 줄 바꿈 */
  word-wrap: break-word; /* 긴 단어가 컨테이너를 넘어가지 않도록 자동으로 줄 바꿈 */
  overflow: auto; /* 콘텐츠가 넘칠 때 스크롤바를 추가 */

  /* 크기 조정 금지 */
  resize: none; /* 사용자가 요소의 크기를 조정하지 못하도록 설정 */

  /* 수정 방지 및 클릭 방지 */
  pointer-events: none; /* 요소에 대한 모든 마우스 이벤트를 비활성화 */
  background-color: #2e2a3a; /* 배경색이 입력 불가능 상태를 나타내도록 설정 */
`;

export const TextContainer = styled.div`
  text-align: center; // 텍스트를 가운데 정렬
  flex: 1; // 항목을 균등하게 배치
  position: relative; // 수직 구분선을 위한 상대 위치 설정
`;

export const LectureText = styled.div`
  color: var(--Gray-Scale-600, #756f7e);
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 138.462% */
  letter-spacing: -0.078px;
  margin-bottom: 8px; // 텍스트와 숫자 간의 간격
`;

export const CustomText = styled.div`
  color: var(--Gray-Scale-300, #d7d3de);
  font-family: 'Pretendard Variable';
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 122.222% */
  letter-spacing: -0.408px;
`;

export const NameText = styled.div`
  color: var(--Gray-Scale-200, #e8e3ee);
  text-align: center;
  font-family: 'Pretendard Variable';
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 122.222% */
  letter-spacing: -0.408px;
`;

export const Number = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
  color: #bcb8c3; // 텍스트 색상 (예: 다크 그레이)
  font-size: 16px; // 숫자의 크기 조절
`;

export const Divider = styled.div`
  background: #262231;
  position: absolute;
  top: 50%;
  left: 100%;
  width: 1px; // 구분선의 두께
  height: 80%; // 구분선의 높이
  transform: translateY(-50%); // 구분선을 가운데로 정렬
`;

export const IconWrapper = styled.div`
  margin-left: auto; // 오른쪽으로 밀어내기
  display: flex;
  align-items: center; // 아이콘 수직 가운데 정렬
`;

export const StyledImage = styled.img`
  width: 70px; // 원하는 너비
  height: 70px; // 원하는 높이
  border-radius: 50%; // 동그라미 형태를 만들기 위한 border-radius
  object-fit: cover; // 이미지가 영역에 맞게 잘리도록
  border: 0px solid #ccc; // 테두리 색상 (선택 사항)
`;

export const TitleArea = styled.div`
  display: flex;
  justify-content: space-between;

  > :last-child {
    border: 1px solid var(--color-white);
    border-radius: 1.4rem;
    padding: 0.4rem 1.8rem;
    align-self: center;
  }
`;

export const DetailArea = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BottomArea = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding-top: 0.6rem;

  > p {
    padding: 1.5rem 0;
    text-align: center;

    :first-child {
      border-right: 1px solid var(--color-white);
    }
  }
`;

export const TabContainer = styled.div`
  display: flex;
  border-bottom: 2px solid #ccc;
  margin-bottom: 1rem;
`;

export const Tab = styled.div`
  flex: 1;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  position: relative;
  font-size: 16px;
  background-color: ${props => props.theme.palette.brand100};
  border-bottom: ${props => props.theme.palette.brand100};
  color: ${props => props.theme.palette.brand400};
  transition:
    background-color 0.3s,
    color 0.3s;
`;

export const TabContent = styled.div`
  padding: 20px;
  background-color: #f9f9f9;
`;

// 스타일 정의
export const TopTabContainer = styled.div`
  margin-top: 32px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-around; // 탭 항목을 좌우로 균등 배치
  width: 100%; // 전체 페이지 너비를 차지하도록 설정
  box-sizing: border-box; // padding과 border가 전체 너비에 포함되도록 설정
  padding: 0; // 패딩을 0으로 설정 (필요에 따라 조정 가능)
  background-color: var(--color-background); // 배경색 설정
`;

interface TopTabProps {
  active?: boolean; // active가 optional인 경우
}
export const TopTab = styled.div<TopTabProps>`
  color: ${props => (props.active ? '#bcb8c3' : '#756f7e')};
  padding: 12px 20px;
  font-weight: 500;
  cursor: pointer;
  font-size: 17px;
  position: relative;
  letter-spacing: -0.41px;
  line-height: 22px;
  font-style: normal;
  &:hover {
    color: #bcb8c3; // 호버 시 배경색 변경
  }
`;

export const ActiveTabIndicator = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 4px;
  background-color: ${props => props.theme.palette.brand400};
`;

export const ContentContainer = styled.div`
  padding: 20px;
`;

export const TextareaWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const TextareaArea = styled.div<{ height: number }>`
  /* position: relative; */
  width: 100%;
  height: ${props => props.height}rem;
  border: 1px solid var(--color-gray-second);
  border-radius: 0.5rem;

  & > textarea:focus {
    outline: none;
  }
`;

export const TextareaTag = styled.textarea`
  width: 100%;
  height: 100%;
  padding: 1rem 0.75rem;
  resize: none;
  color: var(--color-white);
  font-size: 1.6rem;
  background-color: transparent;
  border: none;
`;

export const ModalMainText = styled.div`
  color: var(--Gray-Scale-400, #bcb8c3);
  font-family: 'Pretendard Variable';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px; /* 131.25% */
  letter-spacing: -0.32px;
`;

export const ModalContainer = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const ModalTextField = styled.input`
  border-radius: 8px;
  border: 1px solid var(--BG-bg-500, #373245);
  display: flex;
  padding: 16px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
`;

export const ModalMemoField = styled.textarea`
  border-radius: 8px;
  border: 1px solid var(--BG-bg-500, #373245);
  display: flex;
  height: 160px;
  padding: 16px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  color: #ffffff;
  background-color: #373245;

  // 포커스 상태에서 스타일 변경
  &:focus {
    color: #000; // 포커스 상태에서의 글씨 색상 변경
    background-color: #ffffff;
  }

  // 선택된 텍스트의 스타일 변경
  ::selection {
    background: #373245; // 선택된 텍스트 배경색
    color: #fff; // 선택된 텍스트 색상
  }
`;

export const ModalButton = styled.button`
  display: flex;
  padding: 12px 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  border-radius: 8px;
  background: var(--BG-bg-600, #2e2a3a);
`;

export const ModalButtonContainer = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  align-self: stretch;
`;

export const ButtonTabContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const StyledTab = styled.div<{ active: boolean }>`
  display: flex;
  padding: 12px 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  border: 1px solid
    ${({ active }) =>
      active ? 'var(--Brand-400, #7750e9)' : 'var(--bg-700, #262231)'};
  border-radius: 8px;
  background: var(--bg-600, #2e2a3a);
`;
